import { useQuery } from '@apollo/client'
import { Nullable } from '@dai/common'

import { useRefresh } from '@/contexts/RefreshContext'
import {
  GET_TENANT_STORES,
  GetTenantStoresQuery,
  GetTenantStoresQueryVariables,
} from '@/graphql'

export const useIsSingleStore = (storeIds: Nullable<string[]>) => {
  const { data, refetch, loading } = useQuery<
    GetTenantStoresQuery,
    GetTenantStoresQueryVariables
  >(GET_TENANT_STORES, {
    notifyOnNetworkStatusChange: true,
    variables: {
      pagination: { limit: 100, offset: 0 },
    },
  })

  const overlappingStores =
    data?.tenantStores?.results.filter(store =>
      storeIds?.length ? storeIds?.includes(store.id) : true,
    ) || []

  useRefresh(refetch)

  return {
    loading,
    isSingleStore: overlappingStores.length === 1,
    totalStores: overlappingStores.length,
  }
}
